var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group", class: { required: _vm.required } },
    [
      _vm.label
        ? _c("label", [
            _vm._v(_vm._s(_vm.label)),
            _vm.required ? _c("sup", [_vm._v("*")]) : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        staticClass: "form-control",
        attrs: {
          name: _vm.name,
          type: _vm.type,
          placeholder: _vm.placeholder,
          autocomplete: _vm.autocomplete,
        },
        domProps: { value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event.target.value)
          },
          blur: function ($event) {
            return _vm.$emit("blur")
          },
        },
      }),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.vErrors.has(_vm.errorName),
              expression: "vErrors.has(errorName)",
            },
          ],
          staticClass: "control has-icon has-icon-right",
        },
        [
          _c("i", {
            staticClass: "fa fa-warning",
            staticStyle: { color: "#E74C3C" },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "help has-error" }, [
            _vm._v(" " + _vm._s(_vm.vErrors.first(_vm.errorName))),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }